import { SVGProps } from 'react';

export const HorizontalStick = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="80" height="2" viewBox="0 0 80 2" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="80" height="2" fill="#F5F5FA" />
    </svg>
  );
};
